import { Button } from "../../../../components";

const MenuSuperiorLista = ({ setOpenBaixarXmlDialog }) => {
  const onClickBaixarXml = () => {
    setOpenBaixarXmlDialog(true);
  };

  return (
    <div className="d-flex align-items-center justify-content-start">
      <Button
        id="baixarXml"
        name="baixarXml"
        className="ms-3"
        variant="outlined"
        color="primary"
        onClick={onClickBaixarXml}
      >
        Baixar XML
      </Button>
    </div>
  );
};

export default MenuSuperiorLista;
